import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Underwriting } from './underwriting.entity';

export class CreateUnderwritingDto extends Omit(Underwriting, [...BaseEntityFieldsArray, 'status', 'result']) {}
